import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import client from "@/lib/api";

/**
 * Fires a single non-blocking POST to /traffic/track every time the SPA route
 * changes. Skips admin/account/checkout/login/register — those stay private.
 * Backend handles bot-filtering, geo lookup, and IP hashing.
 *
 * Also pushes a Google Analytics 4 `page_view` event on every route change so
 * SPA navigations are tracked correctly in GA. Safe no-op when gtag isn't
 * loaded (e.g. the Measurement ID placeholder hasn't been replaced yet).
 */
export default function AnalyticsBeacon() {
  const { pathname } = useLocation();

  useEffect(() => {
    const PRIVATE = ["/admin", "/account", "/checkout", "/login", "/register", "/reset-password", "/forgot-password"];
    if (PRIVATE.some((p) => pathname === p || pathname.startsWith(p + "/"))) return;
    client
      .post("/traffic/track", { path: pathname, referrer: document.referrer || "" })
      .catch(() => { /* analytics must never break a render */ });

    // GA4 SPA page_view ping
    try {
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
          page_path: pathname + (window.location.search || ""),
          page_title: document.title,
          page_location: window.location.href,
        });
      }
    } catch (_e) { /* never let analytics break the render */ }
  }, [pathname]);

  return null;
}
